interface EmojiTriggerIconProps {
  className?: string;
}

function EmojiTriggerIcon({ className = "h-5 w-5" }: EmojiTriggerIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="9" cy="10" r="1" fill="currentColor" />
      <circle cx="15" cy="10" r="1" fill="currentColor" />
      <path
        d="M8.5 14.2c1.1 1.4 2.4 2.1 3.5 2.1s2.4-.7 3.5-2.1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default EmojiTriggerIcon;
